module.exports = __webpack_public_path__ + "static/media/RiskIt_Icon_White.a45be67a.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/ico/RiskIt_Icon_White.svg
// module id = 289
// module chunks = 0